import { ActionContext } from "vuex";
import { RootState } from "@/store";
import {
  StateFormEmail,
  StateSaveFormEmail,
} from "@/store/formEmail/types_formEmail";
import { FormEmails } from "@/model/FormEmails";
import urls from "@/constants/urls";

export const formEmail_store = {
  state: {
    formEmail: null,
    formEmailStatusSave: StateSaveFormEmail.initial,
  },
  mutations: {
    setFormEmail(state: StateFormEmail, formEmail: FormEmails): void {
      state.formEmail = formEmail;
    },
    setFormEmailStatusSave(
      state: StateFormEmail,
      formEmailStatusSave: StateSaveFormEmail
    ): void {
      state.formEmailStatusSave = formEmailStatusSave;
    },
  },
  actions: {
    saveFormEmail(
      context: ActionContext<StateFormEmail, RootState>,
      formEmail: FormEmails
    ): void {
      const data = {
        email: formEmail.email,
        name: formEmail.name,
        comment: "",
      };
      context.commit("setFormEmailStatusSave", StateSaveFormEmail.loading);
      fetch(urls.url_to_save_email, {
        method: "POST", // or 'PUT'
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error();
          }
          return response.json();
        })
        .then(() => {
          context.commit("setFormEmailStatusSave", StateSaveFormEmail.success);
          context.commit("setFormEmail", formEmail);
        })
        .catch(() => {
          context.commit("setFormEmailStatusSave", StateSaveFormEmail.fail);
        });
    },
  },
  getters: {
    getFormEmailStatusSave(state: StateFormEmail): StateSaveFormEmail {
      return state.formEmailStatusSave;
    },
  },
};
